import cx from 'clsx';

import type { ProductOption } from './types';

type Props = {
  option: ProductOption;
  disabled: boolean;
};

export function ProductOptionItem({ option, disabled }: Props) {
  return (
    <div className="flex min-h-[44px] flex-col justify-center">
      <p
        className={cx([
          'text-paragraph typo-paragraph100-regular break-all',
          disabled && '!text-disabled',
        ])}
      >
        {option.name}
      </p>
      {disabled ? (
        <p className="mt-2 text-disabled typo-paragraph300-semibold">
          일시 품절
        </p>
      ) : (
        !option.isDefault && (
          <p className="mt-2 break-all text-hint typo-paragraph100-regular">
            {option.priceDifferenceText}
          </p>
        )
      )}
    </div>
  );
}
